import React from 'react';
import { useMatchScreenWidth, IconButton, AddTwoToneIcon, Button, SpinnerIcon } from '@keplerco/core';

export function IncludeEntityCard({ title, subtitle, buttonText, isLoading, action }: { title: string; subtitle: string; buttonText?: string; isLoading?: boolean; action: () => void }) {
  const isMobile = useMatchScreenWidth(1500);
  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>
        <div>
          <h6>{title}</h6>
          <small>{subtitle}</small>
        </div>
        {isMobile ? (
          <IconButton onClick={action} iconType="fill" borderColour="borders" backgroundColour="cards" borderRadius="10px" borderWidth={1}>
            {isLoading ? <SpinnerIcon /> : <AddTwoToneIcon />}
          </IconButton>
        ) : (
          <Button isLoading={isLoading} loaderText={buttonText ?? 'Adding...'} type="button" square theme="dark" onClick={action}>
            <div style={{ display: 'flex', gap: 15, alignItems: 'center', minWidth: 100, whiteSpace: 'nowrap' }}>
              <AddTwoToneIcon />
              {buttonText ?? 'Add'}
            </div>
          </Button>
        )}
      </div>
    </div>
  );
}
